import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    Inject,
    ViewChild,
    ElementRef,
    OnDestroy
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';

import { AssignmentService } from '@/services/assignment-student.service';
import { ConfigService } from '@/services/config.service';
import { LoginService } from '@/services/login.service';

import { Assignment } from '@/structures/assignment';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-upload-devoir',
    templateUrl: './upload-devoir.component.html',
    styleUrls: ['./upload-devoir.component.scss'],
    standalone: false
})
export class UploadDevoirComponent implements OnInit, OnDestroy {
    @ViewChild('fileElement', { static: true }) fileElement: ElementRef;
    file: File;
    fileToUpload: File;

    uploading: boolean;

    @Output() openErrorDialog: EventEmitter<string> = new EventEmitter();
    uploadDevoir$: Subscription;

    constructor(
        @Inject(MAT_DIALOG_DATA) private assignment: Assignment,
        private dialogRef: MatDialogRef<UploadDevoirComponent>,
        private assignmentService: AssignmentService,
        private configService: ConfigService,
        private loginService: LoginService
    ) {}

    ngOnInit() {
        this.fileToUpload = undefined;
        this.uploading = false;
    }

    ngOnDestroy() {
        if (this.uploadDevoir$) {
            this.uploadDevoir$.unsubscribe();
        }
    }

    getIconStyle(): string {
        return this.assignmentService.getIcon(this.assignment);
    }

    getAssignmentTitle(): string {
        return this.assignment.title;
    }

    getAssignmentInformation(): string {
        const options: any = {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit'
        };

        if (this.assignment.timestart && !this.assignment.timeend) {
            return `Devoir à rendre à partir du ${new Date(
                this.assignment.timestart
            ).toLocaleString('fr-FR', options)}`;
        } else if (this.assignment.timestart && this.assignment.timeend) {
            return `Devoir à rendre du ${new Date(this.assignment.timestart).toLocaleString(
                'fr-FR',
                options
            )} au ${new Date(this.assignment.timeend).toLocaleString('fr-FR', options)} `;
        } else if (!this.assignment.timestart && this.assignment.timeend) {
            return `Devoir à rendre jusqu'au ${new Date(this.assignment.timeend).toLocaleString(
                'fr-FR',
                options
            )} `;
        } else {
            return `Devoir à rendre`;
        }
    }

    uploadFile() {
        this.fileElement.nativeElement.click();
    }

    onFilesAdded(event: any) {
        event.preventDefault();
        if (event.dataTransfer) {
            this.fileToUpload = event.dataTransfer.files[0];
        } else if (event.target) {
            this.fileToUpload = event.target.files[0];
        }
        if (this.fileToUpload.size > this.getMaxFileSize()) {
            this.fileToUpload = undefined;
            this.openErrorDialog.next('Votre fichier doit être inférieur à 200 Mo');
        }
        this.fileElement.nativeElement.value = '';
    }

    getMaxFileSize() {
        if (
            this.loginService.getUser().roles.localAdmin ||
            this.loginService.getUser().roles.nationalAdmin
        ) {
            return this.configService.getConfig().maxFileSizeAdmin;
        } else {
            return this.configService.getConfig().maxFileSize;
        }
    }

    deleteFile() {
        this.fileToUpload = undefined;
        this.fileElement.nativeElement.value = '';
    }

    uploadDevoir() {
        if (!this.uploading && this.fileToUpload) {
            this.uploading = true;
            this.uploadDevoir$ = this.assignmentService
                .uploadDevoir(this.fileToUpload, this.assignment)
                .subscribe(
                    () => {
                        this.assignmentService.emitRefreshTracking();
                        this.uploading = false;
                        this.dialogRef.close(true);
                    },
                    (error: HttpErrorResponse) => {
                        this.openErrorDialog.emit(error.error.userMessage);
                        this.uploading = false;
                    }
                );
        }
    }

    /**
     * Ferme la fenêtre d'erreur
     */
    closeDialog() {
        this.dialogRef.close();
    }
}
